/**
 * Maps a SiteFusion asset contentType to an HTML file-input accept string.
 *
 * The returned value is passed to <input type="file" accept="..."> via the
 * useFileInput hook to pre-filter the browser's file-picker dialog.
 * The server still runs its own validation (sfCheckFiletypes); this is a
 * UX improvement only.
 *
 * To add or adjust a mapping, extend the CONTENT_TYPE_ACCEPT_MAP below.
 */
const CONTENT_TYPE_ACCEPT_MAP: Record<string, string> = {
  'file/doc':  '.docx,.doc',
  'file/xls':  '.xlsx,.xls',
  'file/pdf':  '.pdf',
  'file/xml':  '.xml',
  'file/zip':  '.zip',
  'file/idml': '.idml',
}

/**
 * Restricts the upload dialog to specific file types for certain task names.
 * Task-name-based restrictions take precedence over content-type-based ones.
 *
 * To add or adjust a mapping, extend the TASK_NAME_ACCEPT_MAP below.
 */
const TASK_NAME_ACCEPT_MAP: Record<string, string> = {
  'Manuskript Bearbeitung':                '.docx,.docm,.xlsx',
  'Hrsg. Manuskript Überarbeitung':        '.docx,.docm,.xlsx',
  'Autor-Korrektur':                       '.docx,.docm,.xlsx',
  'Hrsg. Autor-Korrektur Überarbeitung':   '.docx,.docm,.xlsx',
}

/**
 * Returns the accept string for the given task name, or undefined if no
 * restriction is defined for that task.
 */
export function getAcceptForTaskName(taskName: string | null | undefined): string | undefined {
  if (taskName == null) return undefined
  return TASK_NAME_ACCEPT_MAP[taskName] ?? undefined
}

/**
 * Returns the accept string for the given contentType, or undefined if no
 * mapping is defined (allowing all file types in that case).
 */
export function getAcceptForContentType(contentType: string | null | undefined): string | undefined {
  if (contentType == null) return undefined
  if (contentType.startsWith('image/')) return 'image/*'
  return CONTENT_TYPE_ACCEPT_MAP[contentType] ?? undefined
}
